import { CONTRACT_AUTHENTICATION_INITIALIZE } from '@app/store/actionTypes';
import { ContractAuthenticationAction } from '@app/store/contract-authentication/actions';

import { fetchParticipantStatusSuccess, ParticipantAction } from '../actions';

type ParticipantIdState = string | null;

const initialState: ParticipantIdState = null;

export default function reducer(
  state: ParticipantIdState = initialState,
  action: ParticipantAction | ContractAuthenticationAction
) {
  switch (action.type) {
    case CONTRACT_AUTHENTICATION_INITIALIZE:
      return initialState;
    case fetchParticipantStatusSuccess.type:
      return action.payload.signer?.participantId || state;
    default:
      return state;
  }
}
